
import {throwError as observableThrowError, Observable} from 'rxjs';
import {Injectable} from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { catchError } from 'rxjs/operators';





@Injectable()
export class PasswordService
{
	constructor(private http: HttpClient){}
	headers = new HttpHeaders();

	checkUserExists(url:any)
	{
		return this.http.get(url,{ withCredentials: true}).
		pipe(catchError(this._errorhandler));
	}
	submitPassword(url:any , uname:any)
	{
		this.headers.append('Content-Type', 'application/json');
		return this.http.post(url,uname,{ withCredentials: true ,headers:this.headers}).
		pipe(catchError(this._errorhandler));
	}

	changePassword(url:any, userdata:any)
	{
		this.headers.append('Content-Type', 'application/json');
		return this.http.post(url,userdata,{ withCredentials: true ,headers:this.headers}).
		pipe(catchError(this._errorhandler));
	}
	_errorhandler(error: Response)
	{
		return observableThrowError(error || "Server Error");	
	}
}